import React from 'react';
const blockName = 'navigation-component';
export default function Navigation({ direction, onClick, caption}){
  return (
    <button
      type='button'
      onClick = { onClick }
      className={ `${ blockName } ${ blockName }--${ direction }` }
    >
      { caption }
    </button>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/components/navigation.js